import _ from "lodash";
import { ReactNode, Component, CSSProperties, ReactElement } from 'react';
import { getRandomKey, isDefined, isFunction } from '@Utils/Micro';
import ListItem, { ListItemProps } from "./ListItem";
import { Props } from "@Utils/ReactProps";
// ================================================================================================
export interface TreeStructureProps extends Props<TreeStructure> {
    FolderStructure: FolderStructure[];
    onListItemSelected?: (key: string) => void;
    style?: CSSProperties;
    onNestedListToggle?: (id: number) => void;
}
// ------------------------------------------------------------------------------------------------
export interface TreeStructureState {
    randomKey: string;
}
// ------------------------------------------------------------------------------------------------
export interface FolderStructure {
    _id: number;
    key?: string;
    path: string;
    parentId: number;
    type: FolderItemType;
    leftIcon?: ReactElement | ReactElement[] | ReactNode | ReactNode[];
    leftFontIcon?: string[];
    primaryText?: string;
    secondaryText?: string;
    children: FolderStructure[];
    rightIcon?: ReactElement | ReactNode;
    style?: CSSProperties;
    tooltip?: string;
    nestedItem?: Array<ReactElement<any>>; /* we can nested custom item in the case of not folder */
    open?: boolean;
    selectable?: boolean;
}
// ---------------------------------------------------------------------------------------------------
export enum FolderItemType {
    Folder = 0,
    Dashboard = 1,
    Switch = 2,
    Button = 3,
    ColorPicker = 4,
    RadioButtons = 5
}
// ---------------------------------------------------------------------------------------------------
export class TreeStructure extends Component<TreeStructureProps, TreeStructureState> {
    constructor(props: TreeStructureProps) {
        super(props);

        this.state = {
            randomKey: "Tree-Structure-" + getRandomKey()
        };

        this.getNestedList = this.getNestedList.bind(this);
    }
    // ---------------------------------------------------------------------------------------------------
    render() {
        return (
            <div style={{ marginTop: -8, marginBottom: -8, ...this.props.style }}>
                {this.getNestedList(this.props.FolderStructure)}
            </div>
        );
    }
    // ---------------------------------------------------------------------------------------------------
    private getNestedList(children: FolderStructure[]): ReactElement<ListItemProps>[] {
        let items: ReactElement<ListItemProps>[] = [];

        children.forEach(element => {
            if (element.children.length > 0) {
                items.push(<ListItem
                    style={element.style}
                    leftIcon={element.leftIcon as ReactElement}
                    initiallyOpen
                    onNestedListToggle={() => this.handleNestedListToggle(element._id)}
                    key={"dashboard-folder-" + element.primaryText}
                    primaryText={element.primaryText}
                    nestedItems={this.getNestedList(element.children)}
                />);
            } else if (element.type != FolderItemType.Folder) {
                if (isDefined(element.nestedItem))
                    items.push(<ListItem
                        style={element.style}
                        key={"dashboard-list-" + element.key}
                        primaryText={element.primaryText}
                        secondaryText={element.secondaryText}
                        onClick={() => {
                            if (isDefined(this.props.onListItemSelected))
                                this.props.onListItemSelected(element.key);
                        }}
                        initiallyOpen
                        nestedItems={element.nestedItem}
                        rightIcon={element.rightIcon}
                        leftIcon={element.leftIcon}
                    />);
                else
                    items.push(<ListItem
                        style={element.style}
                        key={"dashboard-list-" + element.key}
                        primaryText={element.primaryText}
                        secondaryText={element.secondaryText}
                        onClick={() => {
                            if (isDefined(this.props.onListItemSelected))
                                this.props.onListItemSelected(element.key);
                        }}
                        rightIcon={element.rightIcon}
                        leftIcon={element.leftIcon}
                    />);
            }
        });
        return items;
    }
    // ---------------------------------------------------------------------------------------------------
    handleNestedListToggle(id: number) {
        if (isFunction(this.props.onNestedListToggle))
            this.props.onNestedListToggle(id);
    }
    // ---------------------------------------------------------------------------------------------------
}
